<template>
  <transition name="fade">
    <div
      v-if="mainStore.open"
      :key="$root.sessionId"
      class="fixed inset-0 z-[10000] flex h-full max-h-screen w-full flex-col overflow-auto bg-white"
    >
      <template v-if="!mainStore.lightMode">
        <TopBar class="shadow-[-1em 0 .4em olive]" />
        <Wizard :index="mainStore.progress" :count="mainStore.stepsCount" />
      </template>

      <div class="relative w-full grow p-4 sm:overflow-auto">
        <StepsDebugger v-if="!mainStore.lightMode && debug" />
        <div class="mx-auto w-full max-w-[550px] pt-4 md:pt-12">
          <div
            v-show="mainStore.step && !mainStore.alert"
            id="fast-form"
            ref="form"
            method="post"
            action="/projects"
            accept-charset="UTF-8"
            novalidate
            @submit.prevent="false"
          >
            <NameStep v-show="mainStore.step === STEPS.name" :ref="STEPS.name" />
            <DescriptionStep v-show="mainStore.step === STEPS.description" :ref="STEPS.description" />
            <BudgetStep v-show="mainStore.step === STEPS.budget" :ref="STEPS.budget" />
            <ContactStep v-show="mainStore.step === STEPS.contact" :ref="STEPS.contact" />
            <LocationStep v-show="mainStore.step === STEPS.location" :ref="STEPS.location" />
            <OptionsStep v-show="mainStore.step === STEPS.options" :ref="STEPS.options" />
            <transition name="fade">
              <Loader v-if="mainStore.submitting" />
            </transition>
          </div>
        </div>
      </div>

      <Alert v-if="mainStore.alert" class="z-20" />
      <CloseModal />

      <div class="z-10 shadow-[0_10px_1rem_0.1rem]">
        <portal-target name="fast-footer" class="mx-auto flex h-24 w-full max-w-[550px] items-center px-4 py-1 sm:py-4" />
      </div>
    </div>
  </transition>
</template>

<script>
import { mapStores } from 'pinia'
import { STEPS, useMainStore } from '@/apps/fast/store'
import TopBar from './components/TopBar.vue'
import Alert from './components/Alert.vue'
import Wizard from './components/Wizard.vue'
import NameStep from './components/NameStep.vue'
import DescriptionStep from './components/DescriptionStep.vue'
import BudgetStep from './components/BudgetStep.vue'
import ContactStep from './components/ContactStep.vue'
import LocationStep from './components/LocationStep.vue'
import OptionsStep from './components/OptionsStep.vue'
import Loader from './components/Loader.vue'
import CloseModal from './components/CloseModal.vue'
import StepsDebugger from './components/StepsDebugger.vue'

export default {
  name: 'Fast',
  components: {
    TopBar,
    Alert,
    Wizard,
    NameStep,
    DescriptionStep,
    BudgetStep,
    ContactStep,
    LocationStep,
    OptionsStep,
    Loader,
    CloseModal,
    StepsDebugger
  },
  data: () => ({
    STEPS,
    debug: process.env.NODE_ENV === 'development'
  }),
  computed: {
    ...mapStores(useMainStore),
    step() {
      return this.mainStore.step
    }
  },
  watch: {
    step(newStep, oldStep) {
      this.$nextTick(() => {
        const oldStepComponent = this.$refs[oldStep]
        if (typeof oldStepComponent !== 'undefined' && typeof oldStepComponent.exit === 'function') {
          oldStepComponent.exit()
        }
        const newStepComponent = this.$refs[newStep]
        if (typeof newStepComponent !== 'undefined' && typeof newStepComponent.enter === 'function') {
          newStepComponent.enter()
        }
        window._paq.push(['FormAnalytics::scanForForms', this.$refs.form])
      })
    }
  }
}
</script>

<style scoped>
.fade-enter-active,
.fade-leave-active {
  transition: opacity 0.2s;
}

.fade-enter,
.fade-leave-to {
  opacity: 0;
}
</style>

<style lang="scss">
#fast .form-control {
  border-width: 2px !important;

  &:focus {
    border-color: rgba(#006cf1, 0.6) !important;
  }
}
</style>
